export function parseFormattedDate(formattedDate: string) {
  const [date, time] = formattedDate.split(' ');
  return { date, time };
}
